const TRACKABLE_SELECTOR = '[data-track-click]';

const getComponentType = (element) => {
    const component = element.closest('[class*="component-"]');

    if (!component) {
        return '';
    }

    const componentClass = Array.from(component.classList).find((className) => className.startsWith('component-'));
    return componentClass || '';
};

const pushTrackedClick = (element) => {
    window.dataLayer = window.dataLayer || [];

    const payload = {
        event: 'ui_click',
        ui_type: element.dataset.trackType || '',
        ui_location: element.dataset.trackLocation || '',
        ui_label: element.dataset.trackLabel || element.textContent.trim(),
        ui_name: element.dataset.trackName || '',
        ui_section: element.dataset.trackSection || '',
        ui_url: element.getAttribute('href') || '',
        ui_target: element.getAttribute('target') || '_self',
        nav_level: element.dataset.trackNavLevel || '',
        nav_id: element.dataset.trackNavId || '',
        component_id: element.closest('[id^="component-"]')?.id || '',
        component_type: getComponentType(element),
    };

    window.dataLayer.push(payload);
};

const initClickTracking = () => {
    document.addEventListener('click', (event) => {
        const trackableElement = event.target.closest(TRACKABLE_SELECTOR);

        if (!trackableElement) {
            return;
        }

        pushTrackedClick(trackableElement);
    });
};

export default initClickTracking;
